import {IRoutesEndpoints} from '../tenants/shared/interfaces/interface-endpoints';

export const routesEndpoints = require(`../tenants/${process.env.REACT_APP_CLIENT}/routes/endpoint`).default as IRoutesEndpoints;